<!--<div style="font-size: 10px" title="Caret location">{{staticPath}}</div>-->
@if (_path && _path.pathItems.length > 0) {
  <div style="display: flex; flex-wrap: wrap">
    <h2 class="heading-underline" [title]="breadcrumbTip">
      <!-- TODO: AJ - More needs tinkering -->
      @for (item of _path.pathItems; track $index; let i = $index; let isLast = $last) {
        <span
          class="breadcrumbs-path-item"
        [ngClass]="{
          'breadcrumbs-path-item-selectable': item !== selectedPathItem && !item.disabled,
          'breadcrumbs-path-item-disabled': item.disabled,
          'breadcrumbs-selected-path-item': item === selectedPathItem
        }"
          (click)="onPathItemClick(i)"
          >{{ item.label }}</span
          >
          @if (!isLast) {
            <span class="breadcrumbs-delim">{{ delimiterSymbol }}</span>
          }
        }
      </h2>
    </div>
  }

  <!--
  <div style="padding-top: 4px">
    <svg width="88px" height="24px">
      <polygon points="0 0, 80 0, 88 12, 80 24, 0 24" fill="none" stroke="black" stroke-width="1px" />
      <text text-anchor="middle" alignment-baseline="central" x="50%" y="50%">Assignment</text>
    </svg>
    <svg width="88px" height="24px" style="position: relative; left: -8px;">
      <polygon points="0 0, 80 0, 88 12, 80 24, 0 24, 8 12" fill="none" stroke="black" stroke-width="1px" />
      <text text-anchor="middle" alignment-baseline="central" x="50%" y="50%">Candidates</text>
    </svg>
    <svg width="88px" height="24px" style="position: relative; left: -16px;">
      <polygon points="0 0, 88 0, 88 24, 0 24, 8 12" fill="none" stroke="black" stroke-width="1px" />
      <text text-anchor="middle" alignment-baseline="central" x="50%" y="50%">Positions</text>
    </svg>
  </div>
  -->
